import { useEffect } from 'react';
import { useCustomFieldFilterItems } from 'assets/js/pages/engage/workflows/hooks/useCustomFieldFilterItems';
import { useLayout } from 'assets/js/pages/engage/workflows/hooks/useLayout';
import { useSetViewportCenter } from 'assets/js/pages/engage/workflows/hooks/useSetViewportCenter';
import { buildEdges } from 'assets/js/pages/engage/workflows/utils/helpers';
import { useReactFlowStore } from 'assets/js/pages/engage/workflows/utils/store';
import { transformStepsToNodes } from 'assets/js/pages/engage/workflows/utils/transformers';
import { WorkflowUtilityNodeTypeEnum } from 'constants/workflows';
import { useCurrentWorkflow } from 'customHooks/useCurrentWorkflow';
import { useCurrentWorkflowSteps } from 'customHooks/useCurrentWorkflowSteps';
import { filterUndefined } from 'helpers/arrays';
import { difference } from 'lodash';
import { v4 as uuid } from 'uuid';

const useInitializePreviewStore = () => {
    const { data: workflow } = useCurrentWorkflow();
    const { data: workflowSteps } = useCurrentWorkflowSteps();
    const { data: customFieldOptions } = useCustomFieldFilterItems();
    const { setNodes, setEdges } = useReactFlowStore(({ setNodes, setEdges }) => ({
        setNodes,
        setEdges,
    }));

    useSetViewportCenter();
    useLayout();

    useEffect(() => {
        const nodes = transformStepsToNodes({
            steps: workflowSteps,
            workflow,
            selectable: false,
            customFieldOptions,
        });

        const allParentIds = filterUndefined(nodes.map(node => node.data?.parentId));
        const allNodeIds = nodes.map(node => node.id);
        const terminalLeafIds = difference(allNodeIds, allParentIds);

        for (const terminalLeafId of terminalLeafIds) {
            nodes.push({
                id: uuid(),
                data: {
                    type: WorkflowUtilityNodeTypeEnum.LEAF_END,
                    parentId: terminalLeafId,
                },
                type: WorkflowUtilityNodeTypeEnum.LEAF_END,
                position: { x: 0, y: 0 },
                style: { opacity: 0 },
                selectable: false,
            });
        }

        setNodes(nodes, { setEdges: false });
        setEdges(buildEdges(nodes, { isPreview: true }));
    }, [workflow, workflowSteps, customFieldOptions, setNodes, setEdges]);
};

export { useInitializePreviewStore };
